module.exports = __webpack_public_path__ + "static/media/aicon.bdb4a4c4.svg";